import React, { useState } from "react";
import MainHomeContent from "./main-content";
import Sidebar from "./left-side-bar";
import RightSidebar from "./right-side-bar";
import { useAppSelector } from "../../hooks/store-hooks";

const SearchPage = () => {
  const { selectedType } = useAppSelector((state: any) => state.search || {});
  const [userCity, setUserCity] = useState<string[]>([]);
  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="p-4">
        <div className="mx-5 grid grid-cols-1 lg:grid-cols-12 gap-4">
          {/* Left Sidebar */}
          <Sidebar />

          {/* Main Content */}
          <MainHomeContent userCity={userCity} />

          {selectedType === "user" && (
            <RightSidebar setUserCity={setUserCity} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchPage;
